import {CustomerType} from "../live/live.config";

export const ReportMenu: REPORTMEUSCONFIG = [
  {
    header: "Performance Reports",
    description: "",
    order: 4,
    menus: [
      {
        icon: "",
        menu: "Distance",
        menu_description:
          "Total miles/kilometers traveled by the vehicle over a specified time period, providing insights into usage patterns and maintenance needs.",
        url: "/api/reports/distance/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle/Name"
          }
        ],
        activeColumns: ["vehicleName"],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "distanceHeader",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },

      {
        icon: "",
        menu: "Speed",
        menu_description:
          "Average and maximum velocity at which the vehicle travels, useful for analyzing driving behavior and compliance with speed regulations",
        url: "/api/reports/speed/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle/Name"
          }
        ],
        activeColumns: ["vehicleName"],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "speedHeader",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      {
        icon: "",
        menu: "Trips",
        menu_description:
          "Individual journeys made by the vehicle from start to end points, quantifying frequency of use and typical travel patterns",
        url: "/api/reports/trips/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle/Name"
          }
        ],
        activeColumns: ["vehicleName"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "MIS",
        menu_description:
          "Individual journeys made by the vehicle from start to end points, quantifying frequency of use and typical travel patterns",
        url: "/api/reports/mis",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "day",
            name: "DAY",
            type: "String"
          },
          {
            uid: "vendorName",
            name: "VENDOR NAME",
            type: "String"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE NO",
            type: "String"
          },
          {
            uid: "tripName",
            name: "ROUTE NAME",
            type: "String"
          },
          {
            uid: "tripStartedDateTime",
            name: "TRIP START TIME",
            type: "Time"
          },
          {
            uid: "tripCompletedDateTime",
            name: "TRIP COMPLETED TIME",
            type: "Time"
          },
          {
            uid: "totalHoursMillis",
            name: "TOTAL HOURS",
            type: "Duration"
          },
          {
            uid: "tripTypeStr",
            name: "TYPE",
            type: "String"
          },
          {
            uid: "driverName",
            name: "DRIVER NAME",
            type: "String"
          },
          {
            uid: "capacity",
            name: "CAPACITY",
            type: "Number"
          },
          {
            uid: "occupancy",
            name: "OCCUPANCY",
            type: "Number"
          },
          {
            uid: "distance",
            name: "TOTAL KM",
            type: "Number"
          },
          {
            uid: "facilityName",
            name: "FACILITY",
            type: "String"
          },
          {
            uid: "vehicleType",
            name: "VEHICLE TYPE",
            type: "String"
          },
          {
            uid: "tripStatusStr",
            name: "TRIP STATUS",
            type: "String"
          },
          {
            uid: "overSpeed",
            name: "OVER SPEED",
            type: "Number"
          },
          {
            uid: "harshBraking",
            name: "HARSH BRAKING",
            type: "Number"
          },
          {
            uid: "suddenAcceleration",
            name: "SUDDEN ACCELERATION",
            type: "Number"
          },
          {
            uid: "extraKm",
            name: "EXTRA KM",
            type: "Number"
          }
        ],
        activeColumns: [
          "date",
          "day",
          "vendorName",
          "vehicleName",
          "tripName",
          "tripStartedDateTime",
          "tripCompletedDateTime",
          "totalHoursMillis",
          "tripTypeStr",
          "driverName",
          "capacity",
          "occupancy",
          "distance",
          "facilityName",
          "vehicleType",
          "tripStatusStr",
          "overSpeed",
          "harshBraking",
          "suddenAcceleration",
          "extraKm"
        ],
        acceptCustomerType: [CustomerType.EMPLOYEETRACKING]
      },
      {
        icon: "",
        menu: "IVMS/IDMS Trip Report",
        menu_description:
          "Individual journeys made by the vehicle from start to end points, quantifying frequency of use and typical travel patterns",
        url: "/api/reports/mis",
        method: "POST",
        filters: ["date", "vehicle"],
        // take active column alone not the api uid.
        useConfiguredColumns: true,
        columns: [
          {
            uid: "vehicleName",
            name: "VEHICLE NO",
            type: "String"
          },
          {
            uid: "tripStartedDateTime",
            name: "TRIP START TIME",
            type: "DateTimeSeconds"
          },
          {
            uid: "tripCompletedDateTime",
            name: "TRIP COMPLETED TIME",
            type: "DateTimeSeconds"
          },
          {
            uid: "totalHoursMillis",
            name: "DRIVE TIME",
            type: "Duration"
          },
          {
            uid: "tripTypeStr",
            name: "TYPE",
            type: "String"
          },
          {
            uid: "driverName",
            name: "DRIVER NAME",
            type: "String"
          },
          {
            uid: "maxSpeed",
            name: "MAX SPEED",
            type: "Number"
          },
          {
            uid: "distance",
            name: "TOTAL KM",
            type: "Number"
          }
        ],
        activeColumns: [
          "vehicleName",
          "tripStartedDateTime",
          "tripCompletedDateTime",
          "totalHoursMillis",
          "tripTypeStr",
          "driverName",
          "maxSpeed",
          "distance"
        ],
        acceptCustomerType: [CustomerType.EMPLOYEETRACKING]
      },
      {
        icon: "",
        menu: "Safety Risk Report",
        menu_description:
          "Highlights unsafe driving events such as, over-speeding, sudden acceleration and harsh braking during trips and Helps improve driver safety, reduce risks, and ensure a safer journey for passengers.",
        url: "/api/reports/safetyRisk",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle Name"
          },
          {
            uid: "from",
            name: "From"
          },
          {
            uid: "to",
            name: "To"
          },
          {
            uid: "time",
            name: "Time"
          },
          {
            uid: "tripCompletedTime",
            name: "Trip type"
          },
          {
            uid: "avgSpeed",
            name: "Avg.Speed"
          },
          {
            uid: "distance",
            name: "Distance"
          },
          {
            uid: "location",
            name: "Location"
          }
        ],
        activeColumns: [
          "vehicleName",
          "from",
          "to",
          "time",
          "tripCompletedTime",
          "avgSpeed",
          "distance",
          "location"
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "nokiaSafetyRisk",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ],
        groupingFilter: [
          {
            id: 3,
            label: "Date",
            url: "/api/reports/safetyRisk/dateGrouped"
          },
          {
            id: 1,
            label: "Vehicle",
            url: "/api/reports/safetyRisk/vehicleGrouped"
          },
          {
            id: 2,
            label: "Driver",
            url: "/api/reports/safetyRisk/driverGrouped"
          }
        ],
        innerFilters: [
          {
            uid: "alertTypes",
            label: "Event Type",
            type: "multiSelect",
            options: [
              {id: 5, name: "Sudden Acceleration"},
              {id: 6, name: "Harsh Breaking"},
              {id: 8, name: "Over Speeding"}
            ],
            defaultValue: [5, 6, 8]
          }
        ]
      },
      {
        icon: "",
        menu: "Feedback",
        menu_description:
          "Shows the trip feedback submitted by employees, including bus timeliness, driver performance and cleanliness ratings, to help improve transport service quality.",
        url: "/api/reports/routeFeedback",
        method: "post",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "phone",
            name: "PHONE",
            type: "String"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "routeName",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "submittedAt",
            name: "SUBMITTED AT",
            type: "Datetime"
          },
          {
            uid: "busTimelinessRating",
            name: "BUS TIMELINESS",
            type: "Number"
          },
          {
            uid: "driverPerformanceRating",
            name: "DRIVER PERFORMANCE",
            type: "Number"
          },
          {
            uid: "busCleanlinessRating",
            name: "BUS CLEANLINESS",
            type: "Number"
          },
          {
            uid: "overAllRating",
            name: "OVERALL RATING",
            type: "Number"
          },
          {
            uid: "comments",
            name: "COMMENTS",
            type: "String"
          }
        ],
        activeColumns: [
          "name",
          "phone",
          "vehicleName",
          "routeName",
          "submittedAt",
          "busTimelinessRating",
          "driverPerformanceRating",
          "busCleanlinessRating",
          "overAllRating",
          "comments"
        ],
        acceptCustomerType: [CustomerType.EMPLOYEETRACKING]
      }
    ]
  },
  {
    header: "Bus Attendance Reports",
    description: "",
    order: 1,
    menus: [
      {
        icon: "",
        menu: "Overview",
        menu_description:
          "Overview data on passenger boarding events across the entire bus fleet, tracking card swipes and entry transactions.",
        url: "/api/nextApi/attendanceReport/busAttendace",
        method: "GET",
        filters: ["date"],
        columns: [
          {
            uid: "studentName",
            name: "Student Name"
          },
          {
            uid: "studentClass",
            name: "Class"
          }
        ],
        activeColumns: ["date", "trackerName", "studentName", "studentClass"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "All Bus Swipes",
        menu_description:
          "Comprehensive data on passenger boarding events across the entire bus fleet, tracking card swipes and entry transactions.",
        url: "/api/reports/vehicle/rfidSwipes/v2",
        method: "GET",
        filters: ["date", "branch"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "userType",
            name: "USER TYPE",
            type: "String"
          },
          {
            uid: "onwardPick",
            name: "ONWARD PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "onwardDrop",
            name: "ONWARD DROP",
            type: "SwipeLocations"
          },
          {
            uid: "returnPick",
            name: "RETURN PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "returnDrop",
            name: "RETURN DROP",
            type: "SwipeLocations"
          },
          {
            uid: "otherSwipes",
            name: "OTHER SWIPES",
            type: "SwipeLocations"
          },
          {
            uid: "assigned",
            name: "WRONG SWIPE",
            type: "Boolean"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "vehicleName",
          "studentClass",
          "studentSection",
          "admissionNo",
          "userType",
          "onwardPick",
          "onwardDrop",
          "returnPick",
          "returnDrop",
          "otherSwipes",
          "assigned"
        ],
        innerFilters: [
          {
            uid: "usersType",
            label: "User Type",
            type: "multiSelect",
            options: [
              {id: "1", name: "Student"},
              {id: "2", name: "Staff"}
            ],
            defaultValue: ["1", "2"]
          }
        ],
        // headerSidebar: [
        //   {
        //     type: "card",
        //     api_url: [""],
        //     menu: "busAttendanceAllBusSwipes",
        //     sidebarHeading: ""
        //   }
        // ],
        // groupingFilter: [
        //   {
        //     id: 1,
        //     label: "Date",
        //     url: "api/reports/vehicle/rfidSwipes/groupedByDate/v2"
        //   },
        //   {
        //     id: 2,
        //     label: "Vehicle",
        //     url: "api/reports/vehicle/rfidSwipes/groupedByVehicle/v2"
        //   }
        // ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Trip attendance",
        menu_description:
          "Track passenger attendance for onward and return trips, including pickup and drop details, vehicle information, swipe status, and wrong swipes.",
        url: "/api/nextApi/attendanceReport/busAttendanceAllBusSwipes",
        method: "GET",
        useConfiguredColumns: true,
        filters: ["date", "branch"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "onwardPickupVehicle",
            name: "ONWARD PICKUP VEHICLE",
            type: "String"
          },
          {
            uid: "returnDropVehicle",
            name: "RETURN DROP VEHICLE",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "userType",
            name: "USER TYPE",
            type: "String"
          },
          {
            uid: "onwardTrip",
            name: "ONWARD TRIP",
            type: "String"
          },
          {
            uid: "onwardStatus",
            name: "ONWARD STATUS",
            type: "String"
          },
          {
            uid: "returnTrip",
            name: "RETURN TRIP",
            type: "String"
          },
          {
            uid: "returnStatus",
            name: "RETURN STATUS",
            type: "String"
          },
          {
            uid: "onwardPick",
            name: "ONWARD PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "onwardDrop",
            name: "ONWARD DROP",
            type: "SwipeLocations"
          },
          {
            uid: "returnPick",
            name: "RETURN PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "returnDrop",
            name: "RETURN DROP",
            type: "SwipeLocations"
          },
          {
            uid: "otherSwipes",
            name: "OTHER SWIPES",
            type: "SwipeLocations"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "onwardPickupVehicle",
          "returnDropVehicle",
          "studentClass",
          "studentSection",
          "admissionNo",
          "userType",
          "onwardTrip",
          "onwardStatus",
          "returnTrip",
          "returnStatus",
          "onwardPick",
          "onwardDrop",
          "returnPick",
          "returnDrop",
          "otherSwipes"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      // {
      //   icon: "",
      //   menu: "Single Bus Swipes",
      //   menu_description:
      //     "Comprehensive data on passenger boarding events across the specific bus fleet, tracking card swipes, and entry transactions.",
      //   url: "/api/reports/vehicle/rfidSwipes/v2",
      //   method: "POST",
      //   filters: ["date", "vehicleSingle"],
      //   columns: [
      //     {
      //       uid: "date",
      //       name: "Date"
      //     },
      //     {
      //       uid: "trackerName",
      //       name: "Bus"
      //     },
      //     {
      //       uid: "studentName",
      //       name: "Student Name"
      //     },
      //     {
      //       uid: "studentClass",
      //       name: "Class"
      //     },
      //     {
      //       uid: "rfid",
      //       name: "Ref. Id/Admission No"
      //     },
      //     {
      //       uid: "onwardPick",
      //       name: "Onward Pickup"
      //     },
      //     {
      //       uid: "onwardDrop",
      //       name: "Onward Drop"
      //     },
      //     {
      //       uid: "returnPick",
      //       name: "Return Pickup"
      //     },
      //     {
      //       uid: "returnDrop",
      //       name: "Return Drop"
      //     }
      //   ],
      //   activeColumns: [
      //     "date",
      //     "trackerName",
      //     "studentName",
      //     "studentClass",
      //     "rfid",
      //     "onwardPick",
      //     "onwardDrop",
      //     "returnPick",
      //     "returnDrop"
      //   ]
      // },
      {
        icon: "",
        menu: "User Swipes",
        menu_description:
          "Number of access control interactions performed by users with assigned RFID cards, tracking entry/exit patterns, and facility usage.",
        url: "/api/reports/user/rfidSwipes/v2",
        method: "POST",
        filters: ["date", "branch"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "userType",
            name: "USER TYPE",
            type: "String"
          },
          {
            uid: "onwardPick",
            name: "ONWARD PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "onwardDrop",
            name: "ONWARD DROP",
            type: "SwipeLocations"
          },
          {
            uid: "returnPick",
            name: "RETURN PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "returnDrop",
            name: "RETURN DROP",
            type: "SwipeLocations"
          },
          {
            uid: "otherSwipes",
            name: "OTHER SWIPES",
            type: "SwipeLocations"
          },
          {
            uid: "incompleteSwipe",
            name: "INCOMPLETE SWIPE",
            type: "Boolean"
          }
        ],
        activeColumns: ["date", "studentName", "admissionNo"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ],
        innerFilters: [
          {
            uid: "usersType",
            label: "User Type",
            type: "multiSelect",
            options: [
              {id: "1", name: "Student"},
              {id: "2", name: "Staff"}
            ],
            defaultValue: ["1", "2"]
          }
        ]

        // headerSidebar: [
        //   {
        //     type: "card",
        //     api_url: [""],
        //     menu: "rfidUserswipeTopbar",
        //     sidebarHeading: ""
        //   }
        // ]
      },
      {
        icon: "",
        menu: "CTT",
        menu_description:
          "Number of student boarding and drop interactions recorded by the caretaker through CTT device, capturing pickup/drop time, assigned vehicle, and route details for both onward and return trips.",
        url: "/api/reports/ctt",
        method: "POST",
        filters: ["date", "branch"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "onwardPickup",
            name: "ONWARD PICKUP",
            type: "Time"
          },
          {
            uid: "onwardDrop",
            name: "ONWARD DROP",
            type: "Time"
          },
          {
            uid: "onwardVehicleName",
            name: "ONWARD VEHICLE",
            type: "String"
          },
          {
            uid: "onwardRouteName",
            name: "ONWARD ROUTE",
            type: "String"
          },
          {
            uid: "returnPickup",
            name: "RETURN PICKUP",
            type: "Time"
          },
          {
            uid: "returnDrop",
            name: "RETURN DROP",
            type: "Time"
          },
          {
            uid: "returnVehicleName",
            name: "RETURN VEHICLE",
            type: "String"
          },
          {
            uid: "returnRouteName",
            name: "RETURN ROUTE",
            type: "String"
          }
        ],
        activeColumns: ["date", "name", "studentClass", "studentSection"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          // CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]

        // headerSidebar: [
        //   {
        //     type: "card",
        //     api_url: [""],
        //     menu: "rfidUserswipeTopbar",
        //     sidebarHeading: ""
        //   }
        // ]
      }
    ]
  },
  {
    header: "RFID Reports",
    description: "",
    order: 6,
    menus: [
      {
        icon: "",
        menu: "Wrong Swipes",
        menu_description:
          "Identifies and categorizes invalid or mismatched RFID swipes to detect configuration or usage errors.",
        url: "/api/reports/wrongSwipes/v2",
        method: "POST",
        filters: ["date", "branch"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "unassignedSwipes",
            name: "UNASSIGNED VEHICLE SWIPES ",
            type: "SwipeTimings"
          },
          {
            uid: "assignedSwipes",
            name: "ASSIGNED VEHICLE SWIPES",
            type: "SwipeTimings"
          }
        ],
        activeColumns: ["date", "studentName", "admissionNo"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "wrongSwipesHeader",
            sidebarHeading: ""
          }
        ]
      },
      {
        icon: "",
        menu: "Transportation Boarding Report",
        menu_description:
          "Displays employee boarding details by comparing assigned bus routes and boarding points with actual boarding records. Helps verify transportation compliance using punch date and time information.",
        url: "/api/reports/vehicle/rfidSwipes/consolidated",
        method: "POST",
        filters: ["date", "vehicle", "branch"],
        columns: [
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "department",
            name: "DEPARTMENT",
            type: "String"
          },
          {
            uid: "section",
            name: "BRANCH",
            type: "String"
          },
          {
            uid: "employeeNo",
            name: "EMPLOYEE NO",
            type: "String"
          },
          {
            uid: "stop",
            name: "STOP",
            type: "String"
          },
          {
            uid: "category",
            name: "CATEGORY",
            type: "String"
          },
          {
            uid: "assignedVehicles",
            name: "ASSIGNED VEHICLES",
            type: "String"
          },
          {
            uid: "assignedVehicleSwipes",
            name: "ASSIGNED VEHICLE SWIPES",
            type: "SwipeTimings"
          },
          {
            uid: "unassignedVehicleSwipes",
            name: "UNASSIGNED VEHICLE SWIPES",
            type: "SwipeTimings"
          },
          {
            uid: "swipes",
            name: "SWIPES",
            type: "SwipeLocations"
          }
        ],
        activeColumns: [
          "name",
          "studentClass",
          "studentSection",
          "admissionNo",
          "stop",
          "category",
          "assignedVehicles",
          "assignedVehicleSwipes",
          "unassignedVehicleSwipes",
          "swipes"
        ],
        acceptCustomerType: [
          // CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING
          // CustomerType.INDIVIDUAL,
          // CustomerType.COLLEGE
        ]
      }
      // {
      //   icon: "",
      //   menu: "Driver Swipes",
      //   menu_description:
      //     "Tracks driver RFID card swipes on vehicles, including login/logout time and swipes on unassigned vehicles.",
      //   url: "/api/reports/driver/rfidSwipes",
      //   method: "POST",
      //   filters: ["date", "vehicle", "branch"],
      //   columns: [
      //     {
      //       uid: "date",
      //       name: "DATE",
      //       type: "Date"
      //     },
      //     {
      //       uid: "driverName",
      //       name: "DRIVER NAME",
      //       type: "String"
      //     },
      //     {
      //       uid: "empId",
      //       name: "DRIVER ID",
      //       type: "String"
      //     },
      //     {
      //       uid: "rfid",
      //       name: "RFID NO",
      //       type: "String"
      //     },
      //     {
      //       uid: "assignedVehicleName",
      //       name: "ASSIGNED VEHICLE",
      //       type: "String"
      //     },
      //     {
      //       uid: "vehicleName",
      //       name: "SWIPED VEHICLE",
      //       type: "String"
      //     },
      //     {
      //       uid: "vehicleMismatch",
      //       name: "WRONG VEHICLE",
      //       type: "Boolean"
      //     },
      //     // {
      //     //   uid: "routeName",
      //     //   name: "ROUTE",
      //     //   type: "String"
      //     // },
      //     {
      //       uid: "totalSwipes",
      //       name: "TOTAL SWIPES",
      //       type: "Number"
      //     },
      //     {
      //       uid: "firstSwipe",
      //       name: "FIRST SWIPE",
      //       type: "Time"
      //     },
      //     {
      //       uid: "lastSwipe",
      //       name: "LAST SWIPE",
      //       type: "Time"
      //     },

      //     {
      //       uid: "others",
      //       name: "OTHER SWIPE(S)",
      //       type: "time"
      //     }
      //   ],
      //   activeColumns: [
      //     "date",
      //     "driverName",
      //     "empId",
      //     "rfid",
      //     "vehicleName",
      //     "firstSwipe",
      //     "lastSwipe"
      //   ],
      //   acceptCustomerType: [
      //     CustomerType.SCHOOL,
      //     CustomerType.EMPLOYEETRACKING,
      //     CustomerType.INDIVIDUAL,
      //     CustomerType.COLLEGE
      //   ]
      // }
    ]
  },
  {
    header: "Campus Attendance Reports",
    description: "",
    order: 3,
    menus: [
      {
        icon: "",
        menu: "Overview",
        menu_description:
          "Overview logs campus attendance via UHF/biometric swipes with user identity",
        url: "/api/nextApi/attendanceReport/campusAttendace",
        method: "POST",
        filters: ["date"],
        innerFilters: [
          {
            uid: "source",
            label: "Source",
            type: "selectBoxSingle",
            options: [
              {id: "0", name: "All"},
              {id: "1", name: "Biometric"},
              {id: "2", name: "UHF"}
            ],
            defaultValue: "0"
          },
          {
            uid: "userType",
            label: "User Type",
            type: "selectBoxSingle",
            options: [
              {id: "1", name: "Student"},
              {id: "2", name: "Staff"}
            ],
            defaultValue: "1"
          },
          {
            uid: "userStatus",
            label: "Active and Inactive User",
            institutionIds: [1502],
            type: "multiSelect",
            options: [
              {id: "1", name: "Active User"},
              {id: "2", name: "InActive User"}
            ],
            defaultValue: ["1"]
          }
        ],
        columns: [
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "uhfId",
            name: "UHF ID",
            type: "String"
          },
          {
            uid: "biometricId",
            name: "BIOMETRIC ID",
            type: "String"
          }
        ],
        activeColumns: [
          "name",
          "studentClass",
          "studentSection",
          "admissionNo"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          // CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "User Swipes (UHF & Biometric)",
        menu_description:
          "Logs campus attendance via UHF/biometric swipes with user identity, timing, and entry/exit tracking.",
        url: "/api/reports/campusAttendance/v2",
        method: "POST",
        filters: ["date", "hardwareList"],
        innerFilters: [
          {
            uid: "source",
            label: "Source",
            type: "selectBoxSingle",
            options: [
              {id: "0", name: "All"},
              {id: "1", name: "Biometric"},
              {id: "2", name: "UHF"}
            ],
            defaultValue: "0"
          },
          {
            uid: "userType",
            label: "User Type",
            type: "selectBoxSingle",
            options: [
              {id: "1", name: "Student"},
              {id: "2", name: "Staff"}
            ],
            defaultValue: "1"
          }
        ],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "uhfId",
            name: "UHF ID",
            type: "String"
          },
          {
            uid: "biometricId",
            name: "BIOMETRIC ID",
            type: "String"
          },
          {
            uid: "batchStartTime",
            name: "BATCH START TIME",
            type: "Datetime"
          },
          {
            uid: "batchEndTime",
            name: "BATCH END TME",
            type: "Datetime"
          },
          {
            uid: "in",
            name: "IN",
            type: "Time"
          },
          {
            uid: "out",
            name: "OUT",
            type: "Time"
          },
          {
            uid: "attendanceStatus",
            name: "STATUS",
            type: "String"
          },
          {
            uid: "otherSwipes",
            name: "OTHER SWIPES",
            type: "Time"
          },
          {
            uid: "comments",
            name: "COMMENTS",
            type: "String"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "admissionNo",
          "studentClass",
          "studentSection",
          "uhfId",
          "biometricId",
          "batchStartTime",
          "batchEndTime",
          "in",
          "out",
          "attendanceStatus",
          "otherSwipes",
          "comments"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          //CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Canteen Report",
        menu_description:
          "Monitors canteen access using UHF swipe data, capturing canteen timings, eligibility status, etc.",
        url: "/api/reports/canteen/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "uhfId",
            name: "UHF CARD NO",
            type: "String"
          },
          {
            uid: "breakfastInTime",
            name: "BREAKFAST IN TIME",
            type: "Time"
          },
          {
            uid: "breakfastOutTime",
            name: "BREAKFAST OUT TIME",
            type: "Time"
          },
          {
            uid: "lunchInTime",
            name: "LUNCH IN TIME",
            type: "Time"
          },
          {
            uid: "lunchOutTime",
            name: "LUNCH OUT TIME",
            type: "Time"
          },
          {
            uid: "isOpted",
            name: "IS OPTED",
            type: "String"
          },
          {
            uid: "payment",
            name: "PAYMENT",
            type: "String"
          },
          {
            uid: "validityStartDate",
            name: "VALIDITY START DATE",
            type: "Datetime"
          },
          {
            uid: "validityEndDate",
            name: "VALIDITY END DATE",
            type: "Datetime"
          },
          {
            uid: "isAuthorized",
            name: "IS AUTHORISED",
            type: "String"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "admissionNo",
          "studentClass",
          "studentSection",
          "uhfId",
          "breakfastInTime",
          "breakfastOutTime",
          "lunchInTime",
          "lunchOutTime",
          "isOpted",
          "payment",
          "validityStartDate",
          "validityEndDate",
          "isAuthorized"
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "uhfCanteenHeader",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          // CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Gate Attendance",
        menu_description:
          "The report related to a system that monitors or tracks the pickup activities of a guardian or a designated person.",
        url: "/api/reports/gateAttendance",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "entryTime",
            name: "ENTRY TIME",
            type: "Time"
          },
          {
            uid: "exitTime",
            name: "EXIT TIME",
            type: "Time"
          },
          {
            uid: "guardianName",
            name: "GUARDIAN NAME",
            type: "String"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "studentClass",
          "studentSection",
          "admissionNo",
          "entryTime",
          "exitTime",
          "guardianName"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          //CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Visitor Report",
        menu_description:
          "The Visitor Report is related to a system that monitors and tracks visitor entry, exit, and campus presence, including guardian visits, walk-in visitors, and pickup activities.",
        url: "/api/v2/staffApp/visitors/report",
        method: "POST",
        filters: ["date"],
        //tableCardView: "visitorsReport",
        innerFilters: [
          {
            uid: "visitorType",
            label: "Visitor Type",
            type: "multiSelect",
            options: [
              {id: 1, name: "Guardian Visitors"},
              {id: 2, name: "Walk in Visitors"}
            ],
            defaultValue: [1, 2]
          }
        ],
        columns: [
          {
            uid: "visitorType",
            name: "VISITOR TYPE",
            type: "VisitorType"
          },
          {
            uid: "visitorName",
            name: "VISITOR NAME",
            type: "String"
          },
          {
            uid: "visitorImage",
            name: "VISITOR IMAGE",
            type: "VisitorImage"
          },
          {
            uid: "visitorPhoneNumber",
            name: "PHONE NUMBER",
            type: "Number"
          },
          {
            uid: "pickedupStudents",
            name: "PICKED UP STUDENTS",
            type: "PickedUpStudents"
          },
          {
            uid: "reason",
            name: "REASON",
            type: "String"
          },
          {
            uid: "checkInTime",
            name: "CHECK IN TIME",
            type: "Datetime"
          },
          {
            uid: "checkOutTime",
            name: "CHECK OUT TIME",
            type: "Datetime"
          }
        ],
        activeColumns: [
          "visitorType",
          "visitorName",
          "visitorImage",
          "visitorPhoneNumber",
          "pickedupStudents",
          "reason",
          "checkInTime",
          "checkOutTime"
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "visitorReportCard",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  {
    header: "Log Reports",
    description: "",
    order: 2,
    menus: [
      {
        icon: "",
        menu: "Travel Log",
        menu_description:
          " Comprehensive record of all vehicle journeys, capturing start/end locations, timestamps, Avg.speed and distances traveled.",
        url: "/api/reports/travelLog/v2",
        method: "POST",
        filters: ["date", "vehicleSingle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle Name"
          },
          {
            uid: "from",
            name: "From"
          },
          {
            uid: "to",
            name: "To"
          },
          {
            uid: "time",
            name: "Time"
          },
          {
            uid: "tripCompletedTime",
            name: "Trip type"
          },
          {
            uid: "avgSpeed",
            name: "Avg.Speed"
          },
          {
            uid: "distance",
            name: "Distance"
          },
          {
            uid: "location",
            name: "Location"
          }
        ],
        activeColumns: ["vehicleName", "from", "to"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      {
        icon: "",
        menu: "RFID",
        menu_description:
          "Check vehicle entry and exit logs.Make sure RFID swipes are assigned correctly.",
        url: "/api/reports/rfidLogs",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "onwardPickup",
            name: "ONWARD PICKUP",
            type: "Time"
          },
          {
            uid: "onwardDrop",
            name: "ONWARD DROP",
            type: "Time"
          },
          {
            uid: "onwardVehicleName",
            name: "ONWARD VEHICLE",
            type: "String"
          },
          {
            uid: "onwardRouteName",
            name: "ONWARD ROUTE",
            type: "String"
          },
          {
            uid: "returnPickup",
            name: "RETURN PICKUP",
            type: "Time"
          },
          {
            uid: "returnDrop",
            name: "RETURN DROP",
            type: "Time"
          },
          {
            uid: "returnVehicleName",
            name: "RETURN VEHICLE",
            type: "String"
          },
          {
            uid: "returnRouteName",
            name: "RETURN ROUTE",
            type: "String"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "studentClass",
          "studentSection",
          "onwardPickup",
          "onwardDrop",
          "onwardVehicleName",
          "onwardRouteName",
          "returnPickup",
          "returnDrop",
          "returnVehicleName",
          "returnRouteName"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      {
        icon: "",
        menu: "Biometric",
        menu_description:
          "Check campus attendance records.Make sure biometric logs are assigned correctly.",
        url: "/api/reports/biometricRecord/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Datetime"
          },
          {
            uid: "deviceName",
            name: "DEVICE NAME",
            type: "String"
          },
          {
            uid: "biometricId",
            name: "BIOMETRIC ID",
            type: "String"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "userType",
            name: "USER TYPE",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          }
        ],
        activeColumns: [
          "date",
          "deviceName",
          "biometricId",
          "name",
          "userType",
          "studentClass",
          "studentSection",
          "admissionNo"
        ],
        innerFilters: [
          {
            uid: "userType",
            label: "User Type",
            type: "selectBoxSingle",
            options: [
              {id: "1", name: "Student"},
              {id: "2", name: "Staff"}
            ],
            defaultValue: "1"
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      {
        icon: "",
        menu: "User Histories",
        menu_description:
          "Chronological records of individual user interactions and activities within the system, capturing patterns of engagement and usage over time.",
        url: "/api/reports/user/histories/v2",
        method: "POST",
        filters: [],
        columns: [
          {
            uid: "userName",
            name: "User Name"
          },
          {
            uid: "name",
            name: "Student Name"
          },
          {
            uid: "phone",
            name: "Phone Number"
          },
          {
            uid: "email",
            name: "Email"
          },
          {
            uid: "parentName",
            name: "Parent Name"
          },
          {
            uid: "userClass",
            name: "Class"
          },
          {
            uid: "section",
            name: "Section"
          },
          {
            uid: "uniqueId",
            name: "Stud ID"
          },
          {
            uid: "operation",
            name: "Operation"
          },
          {
            uid: "dateTime",
            name: "Date - Time"
          },
          {
            uid: "updatedBy",
            name: "Updated By"
          }
        ],
        activeColumns: ["userName", "name", "Phone"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "User Credentials",
        menu_description:
          "Authentication information that verifies identity and grants appropriate system access, typically consisting of usernames and passwords or other verification factors.",
        url: "/api/reports/user/credentials/v2",
        method: "POST",
        filters: [],
        columns: [
          {
            uid: "userName",
            name: "User Name"
          },
          {
            uid: "phoneNumber",
            name: "Phone Number"
          },
          {
            uid: "message",
            name: "Message"
          },
          {
            uid: "enrollmentId",
            name: "Enrollment Id"
          }
        ],
        activeColumns: ["userName", "enrollmentId", "phoneNumber", "message"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Capacity Utilization",
        menu_description:
          "Analyzes vehicle usage efficiency by tracking user counts and trip-type distribution per route.",
        url: "/api/reports/capacityUtilization/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "route",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "tripType",
            name: "TRIP TYPE",
            type: "String"
          },
          {
            uid: "total",
            name: "TOTAL USERS",
            type: "Number"
          },
          {
            uid: "pick",
            name: "PICK USERS",
            type: "Number"
          },
          {
            uid: "pickPercentage",
            name: "PICK %",
            type: "Number"
          },
          {
            uid: "drop",
            name: "DROP USERS",
            type: "Number"
          },
          {
            uid: "dropPercentage",
            name: "DROP %",
            type: "Number"
          }
        ],
        activeColumns: ["date", "vehicleName", "route", "total"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Speed Breach",
        menu_description:
          "Records speed violations per vehicle to monitor and enforce safe driving behavior.",
        url: "/api/reports/speedBreach/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "count",
            name: "COUNT",
            type: "Number"
          }
        ],
        activeColumns: ["date", "vehicleName", "count"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "UHF Records",
        menu_description:
          "Records student scan data with UHF RFID, including date, location, and basic student info for tracking.",
        url: "/api/reports/uhfRecord/v2",
        method: "",
        filters: ["date", "uhfGroup"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "uhfId",
            name: "UHF ID",
            type: "String"
          },
          {
            uid: "locationId",
            name: "LOCATION ID",
            type: "String"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "schoolGroup",
            name: "SCHOOL GROUP",
            type: "String"
          },
          {
            uid: "code",
            name: "CODE",
            type: "String"
          },
          {
            uid: "batch",
            name: "BATCH",
            type: "String"
          },
          {
            uid: "grNo",
            name: "GR NO",
            type: "String"
          }
        ],
        activeColumns: ["date", "uhfId", "locationId", "name", "studentClass"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          //CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  {
    header: "Alert Reports",
    description: "",
    order: 3,
    menus: [
      {
        icon: "",
        menu: "Notification",
        menu_description:
          "Provides a detailed record of all notifications sent through the system, helping you track alerts, monitor communication activity, and review delivery history.",
        url: "/api/reports/notifications/v2",
        method: "post",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "enrollNo",
            name: "Enroll NO"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "sectionName",
            name: "Section"
          },
          {
            uid: "uhfId",
            name: "UHF Id"
          },
          {
            uid: "msg",
            name: "Notification Content"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "enrollNo",
          "className",
          "sectionName",
          "uhfId",
          "msg"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Announcement History",
        menu_description:
          "Shows the complete history of announcements shared in the system, making it easy to review past messages, communication timelines, and important updates.",
        url: "/api/reports/announcements/v2",
        method: "post",
        filters: ["date"],
        columns: [
          {
            uid: "time",
            name: "DATE",
            type: "Datetime"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "route",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "msg",
            name: "MESSAGE",
            type: "String"
          },
          {
            uid: "userCount",
            name: "USER COUNT",
            type: "Number"
          },
          {
            uid: "notificationCount",
            name: "NOTIFICATION COUNT",
            type: "Number"
          },
          {
            uid: "smsCount",
            name: "SMS COUNT",
            type: "Number"
          }
        ],
        activeColumns: [
          "time",
          "vehicleName",
          "route",
          "msg",
          "userCount",
          "notificationCount",
          "smsCount"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Alert History",
        menu_description:
          "Provides a detailed history of vehicle and driver alerts generated by the system, helping you monitor driving behaviour, track route and trip events, and review safety incidents.",
        url: "/api/reports/fleet/alerts",
        method: "post",
        filters: ["date"],
        columns: [
          {
            uid: "alertTypeName",
            name: "ALERT TYPE",
            type: "String"
          },
          {
            uid: "routeName",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "driverName",
            name: "DRIVER",
            type: "String"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "time",
            name: "TIME",
            type: "Datetime"
          },
          {
            uid: "message",
            name: "MESSAGE",
            type: "String"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "Locations"
          }
        ],
        activeColumns: [
          "alertTypeName",
          "routeName",
          "driverName",
          "vehicleName",
          "time",
          "message",
          "location"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  // Hardware status start
  {
    header: "Hardware Status Reports",
    description: "",
    order: 5,
    menus: [
      {
        icon: "",
        menu: "Biometric",
        menu_description:
          "This report helps you see which fingerprint or face recognition devices are active and which require maintenance.",
        url: "/api/reports/biometric/status/v2?loginUserId=",
        method: "post",
        filters: [],
        columns: [
          {
            uid: "deviceName",
            name: "NAME",
            type: "String"
          },
          {
            uid: "serialNo",
            name: "SERIAL NO",
            type: "String"
          },
          {
            uid: "lastLogTime",
            name: "LAST LOG TIME",
            type: "Datetime"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "String"
          },
          {
            uid: "status",
            name: "STATUS",
            type: "String"
          }
        ],
        activeColumns: [
          "deviceName",
          "serialNo",
          "lastLogTime",
          "location",
          "status"
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "hardwareReportBioMetr",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "UHF",
        menu_description:
          "This report helps you see which long-range RFID scanners (UHF) are working properly and which ones may need attention.",
        url: "/api/reports/uhf/status/v2?loginUserId=",
        method: "post",
        filters: [],
        columns: [
          {
            uid: "ip",
            name: "IP",
            type: "String"
          },
          {
            uid: "lastLogTime",
            name: "LAST LOG TIME",
            type: "Datetime"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "String"
          },
          {
            uid: "status",
            name: "STATUS",
            type: "String"
          }
        ],
        activeColumns: ["ip", "lastLogTime", "location", "status"],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "hardwareReportBioMetr",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  // Hardware status end

  // Fuel Report start
  {
    header: "Fuel Reports",
    description: "",
    order: 6,
    menus: [
      {
        icon: "",
        menu: "Fuel Consumption",
        subHeader: "Fuel Consumption - Detailed ",
        menu_description:
          "Provides a fleet-level view of fuel usage across all vehicles for the selected period, helping monitor overall consumption, filling, theft, mileage, and fuel-related activity.",
        url: "/api/reports/fuel/consolidate",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "vehicleId",
            name: "Vehicle",
            type: "String"
          },
          {
            uid: "date",
            name: "DATE",
            type: "Datetime"
          },
          {
            uid: "startfuel",
            name: "Start Fuel (L)",
            type: "String"
          },
          {
            uid: "endfuel",
            name: "End Fuel (L)",
            type: "String"
          },
          {
            uid: "distance",
            name: "Distance (KM)",
            type: "String"
          },
          {
            uid: "fuelconsumed",
            name: "Fuel Consumed (L)",
            type: "String"
          },
          {
            uid: "mileage",
            name: "Mileage (KM/L)",
            type: "String"
          },
          {
            uid: "fuelfill",
            name: "Fuel Fill",
            type: "String"
          },
          {
            uid: "fueltheft",
            name: "Fuel Theft",
            type: "String"
          }
        ],
        activeColumns: [
          "vehicleId",
          "date",
          "startfuel",
          "endfuel",
          "distance",
          "fuelconsumed",
          "mileage",
          "fuelfill",
          "fueltheft"
        ],
        headerSidebar: [],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Fuel Analytics",
        subHeader: "Fuel Analytics - Detailed ",
        menu_description:
          "Provides a more detailed, vehicle-specific view for one selected vehicle, including fuel trend, current fuel level, mileage, and estimated driving range.",
        url: "/api/reports/fuel/singleVehicle",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Datetime"
          },
          {
            uid: "fuelType",
            name: "TYPE",
            type: "String"
          },
          {
            uid: "prevFuel",
            name: "PREV FUEL (L)",
            type: "Number"
          },
          {
            uid: "currentFuel",
            name: "CURRENT FUEL (L)",
            type: "Number"
          },
          {
            uid: "fuel",
            name: "FUEL (L)",
            type: "Number"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "Locations"
          }
        ],
        activeColumns: [
          "date",
          "fuelType",
          "prevFuel",
          "currentFuel",
          "fuel",
          "location"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  // Fuel Report end
  {
    header: "Route Plan Reports",
    description: "",
    order: 7,
    menus: [
      {
        icon: "",
        menu: "Boarding Point Assignment",
        menu_description:
          "Displays user boarding point assignment details including route, vehicle, timing, active days, and location coordinates.",
        url: "/api/reports/tripanalysis/routePlan/v2",
        method: "POST",
        filters: [],
        columns: [
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "phone",
            name: "PHONE",
            type: "String"
          },
          {
            uid: "route",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "startTime",
            name: "START TIME",
            type: "Time"
          },
          {
            uid: "endTime",
            name: "END TIME",
            type: "Time"
          },
          {
            uid: "activeOnDays",
            name: "ACTIVE ON DAYS",
            type: "String"
          },
          {
            uid: "tripType",
            name: "TRIP TYPE",
            type: "String"
          },
          {
            uid: "bpName",
            name: "BP NAME",
            type: "String"
          },
          {
            uid: "latitude",
            name: "LATITUDE",
            type: "Number"
          },
          {
            uid: "longitude",
            name: "LONGITUDE",
            type: "Number"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "Locations"
          }
        ],
        activeColumns: [
          "name",
          "studentClass",
          "admissionNo",
          "phone",
          "routeName",
          "vehicleName",
          "startTime",
          "endTime",
          "activeOnDays",
          "bpName",
          "latitude",
          "longitude",
          "Location"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  {
    header: "Login & Logout Reports ",
    description: "",
    order: 2,
    menus: [
      {
        icon: "TbReportAnalytics",
        menu: "Distance",
        menu_description:
          "Displays the total distance travelled by vehicles during the selected period, including trip and operational movement.",
        url: "/api/reports/tripanalysis/trip/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "trips",
            name: "TRIPS",
            type: "Number"
          },
          {
            uid: "totalDistance",
            name: "TOTAL DISTANCE(KM)",
            type: "Number"
          },
          {
            uid: "tripDistance",
            name: "TRIP DISTANCE(KM)",
            type: "Number"
          },
          {
            uid: "deadDistance",
            name: "DEAD DISTANCE(KM)",
            type: "Number"
          }
        ],
        activeColumns: [
          "date",
          "vehicleName",
          "trips",
          "totalDistance",
          "tripDistance",
          "deadDistance"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      {
        icon: "TbReportAnalytics",
        menu: "Summary",
        menu_description:
          "Provides an overall operational overview including trips, vehicles, occupancy, distance travelled, and key transport performance metrics.",
        url: "/api/reports/tripanalysis/summary/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "tripReference",
            name: "TRIP REFERENCE",
            type: "String"
          },
          {
            uid: "routeName",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "tripType",
            name: "TRIP TYPE",
            type: "String"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "vehicleSeats",
            name: "VEHICLE SEATS",
            type: "Number"
          },
          {
            uid: "office",
            name: "OFFICE",
            type: "String"
          },
          {
            uid: "source",
            name: "SOURCE",
            type: "String"
          },
          {
            uid: "destination",
            name: "DESTINATION",
            type: "String"
          },
          {
            uid: "scheduledStartTime",
            name: "SCHEDULED START TIME",
            type: "Time"
          },
          {
            uid: "scheduledEndTime",
            name: "SCHEDULED END TIME",
            type: "Time"
          },
          {
            uid: "tripStartedTime",
            name: "TRIP START TIME",
            type: "Time"
          },
          {
            uid: "tripEndedTime",
            name: "TRIP END TIME",
            type: "Time"
          },
          {
            uid: "distance",
            name: "DISTANCE(KM)",
            type: "Number"
          },
          {
            uid: "totalStops",
            name: "TOTAL STOPS",
            type: "Number"
          },
          {
            uid: "totalUsers",
            name: "TOTAL USERS",
            type: "Number"
          },
          {
            uid: "occupancy",
            name: "OCCUPANCY",
            type: "Number"
          },
          {
            uid: "confirmedUsers",
            name: "CONFIRMED USERS",
            type: "Number"
          },
          {
            uid: "shiftTime",
            name: "SHIFT",
            type: "Time"
          },
          {
            uid: "lateness",
            name: "LATENESS",
            type: "Duration"
          }
        ],
        activeColumns: [
          "date",
          "tripReference",
          "routeName",
          "tripType",
          "vehicleName",
          "scheduledStartTime",
          "tripStartedTime",
          "distance",
          "totalUsers",
          "occupancy",
          "lateness"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      {
        icon: "TbReportAnalytics",
        menu: "Users Summary",
        menu_description:
          "Provides an overview of registered users, travel activity, boarding status, and key user transportation metrics.",
        url: "/api/reports/tripanalysis/usersummary/trips/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "tripReference",
            name: "TRIP REFERENCE",
            type: "String"
          },
          {
            uid: "routeName",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "tripType",
            name: "TRIP TYPE",
            type: "String"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "vehicleSeats",
            name: "VEHICLE SEATS",
            type: "Number"
          },
          {
            uid: "office",
            name: "OFFICE",
            type: "String"
          },
          {
            uid: "source",
            name: "SOURCE",
            type: "String"
          },
          {
            uid: "destination",
            name: "DESTINATION",
            type: "String"
          },
          {
            uid: "totalUsers",
            name: "TOTAL USERS",
            type: "Number"
          },
          {
            uid: "scheduledStartTime",
            name: "SCHEDULED START TIME",
            type: "Time"
          },
          {
            uid: "scheduledEndTime",
            name: "SCHEDULED END TIME",
            type: "Time"
          },
          {
            uid: "tripStartedTime",
            name: "TRIP START TIME",
            type: "Time"
          },
          {
            uid: "tripEndedTime",
            name: "TRIP END TIME",
            type: "Time"
          },
          {
            uid: "shiftTime",
            name: "SHIFT",
            type: "Time"
          },
          {
            uid: "vehicleStartTime",
            name: "VEHICLE START TIME",
            type: "Time"
          },
          {
            uid: "vehicleReachingTime",
            name: "VEHICLE REACHING TIME",
            type: "Time"
          },
          {
            uid: "reachingLateness",
            name: "REACHING LATENESS",
            type: "Duration"
          },
          {
            uid: "distance",
            name: "TRIP DISTANCE(KM)",
            type: "Number"
          }
        ],
        activeColumns: [
          "date",
          "tripReference",
          "routeName",
          "tripType",
          "vehicleName",
          "totalUsers",
          "vehicleStartTime",
          "vehicleReachingTime",
          "reachingLateness",
          "distance"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      }
    ]
  }
  // {
  //   header: "Employee Transportation Reports",
  //   description: "",
  //   order: 8,
  //   menus: [
  //     {
  //       icon: "",
  //       menu: "Shift Summary",
  //       menu_description:
  //         "Shift-wise count of employees transported, with a per-vehicle breakdown for each shift.",
  //       // columns are built from the shift list returned by the transport API
  //       url: "/api/nextApi/employeeTransport/shiftReport",
  //       method: "POST",
  //       filters: ["date"],
  //       columns: [
  //         {
  //           uid: "date",
  //           name: "DATE",
  //           type: "String"
  //         },
  //         {
  //           uid: "vehicle",
  //           name: "VEHICLE",
  //           type: "String"
  //         },
  //         {
  //           uid: "total",
  //           name: "TOTAL",
  //           type: "Number"
  //         }
  //       ],
  //       activeColumns: ["date", "vehicle", "total"],
  //       headerSidebar: [
  //         {
  //           type: "card",
  //           api_url: [""],
  //           menu: "employeeShiftSummary",
  //           sidebarHeading: ""
  //         }
  //       ],
  //       acceptCustomerType: [CustomerType.EMPLOYEETRACKING]
  //     }
  //   ]
  // }

  // new work
  // {
  //   header: "Employee Transportation Reports",
  //   description: "",
  //   order: 3,
  //   menus: [
  // {
  //   icon: "",
  //   menu: "Time Driven",
  //   menu_description:
  //     "Tracks the total driving time per employee to support shift analysis, payroll accuracy, and productivity insights.",
  //   url: "/api/reports/travelLog/v2",
  //   method: "POST",
  //   filters: ["date", "vehicleSingle"],
  //   columns: [
  //     {
  //       uid: "vehicleName",
  //       name: "Vehicle Name"
  //     },
  //     {
  //       uid: "from",
  //       name: "From"
  //     },
  //     {
  //       uid: "to",
  //       name: "To"
  //     },
  //     {
  //       uid: "time",
  //       name: "Time"
  //     },
  //     {
  //       uid: "tripCompletedTime",
  //       name: "Trip type"
  //     },
  //     {
  //       uid: "avgSpeed",
  //       name: "Avg.Speed"
  //     },
  //     {
  //       uid: "distance",
  //       name: "Distance"
  //     },
  //     {
  //       uid: "location",
  //       name: "Location"
  //     }
  //   ],
  //   activeColumns: ["vehicleName", "from", "to"],
  //   // should add headerTopBar here

  //   headerSidebar: [
  //     {
  //       type: "card",
  //       api_url: [""],
  //       menu: "nokiaTimeDriven",
  //       sidebarHeading: ""
  //     }
  //   ],
  //   acceptCustomerType: [
  //     CustomerType.SCHOOL,
  //     CustomerType.EMPLOYEETRACKING,
  //     CustomerType.INDIVIDUAL,
  //     CustomerType.COLLEGE,
  //     CustomerType.SME
  //   ]
  // },
  // {
  //   icon: "",
  //   menu: "Sudden Acceleration",
  //   menu_description:
  //     "Tracks the total driving time per employee to support shift analysis, payroll accuracy, and productivity insights.",
  //   url: "/api/reports/travelLog/v2",
  //   method: "POST",
  //   filters: ["date", "vehicleSingle"],
  //   columns: [
  //     {
  //       uid: "vehicleName",
  //       name: "Vehicle Name"
  //     },
  //     {
  //       uid: "from",
  //       name: "From"
  //     },
  //     {
  //       uid: "to",
  //       name: "To"
  //     },
  //     {
  //       uid: "time",
  //       name: "Time"
  //     },
  //     {
  //       uid: "tripCompletedTime",
  //       name: "Trip type"
  //     },
  //     {
  //       uid: "avgSpeed",
  //       name: "Avg.Speed"
  //     },
  //     {
  //       uid: "distance",
  //       name: "Distance"
  //     },
  //     {
  //       uid: "location",
  //       name: "Location"
  //     }
  //   ],
  //   activeColumns: ["vehicleName", "from", "to"],
  //   // topbar
  //   headerSidebar: [
  //     {
  //       type: "card",
  //       api_url: [""],
  //       menu: "nokiaSuddenAcceleration",
  //       sidebarHeading: ""
  //     }
  //   ],
  //   acceptCustomerType: [
  //     CustomerType.SCHOOL,
  //     CustomerType.EMPLOYEETRACKING,
  //     CustomerType.INDIVIDUAL,
  //     CustomerType.COLLEGE,
  //     CustomerType.SME
  //   ]
  // },
  // {
  //   icon: "",
  //   menu: "Over speed",
  //   menu_description:
  //     "Monitors adherence to assigned routes, schedules, and transportation policies for each employee.",
  //   url: "/api/reports/travelLog/v2",
  //   method: "POST",
  //   filters: ["date", "vehicleSingle"],
  //   columns: [
  //     {
  //       uid: "vehicleName",
  //       name: "Vehicle Name"
  //     },
  //     {
  //       uid: "from",
  //       name: "From"
  //     },
  //     {
  //       uid: "to",
  //       name: "To"
  //     },
  //     {
  //       uid: "time",
  //       name: "Time"
  //     },
  //     {
  //       uid: "tripCompletedTime",
  //       name: "Trip type"
  //     },
  //     {
  //       uid: "avgSpeed",
  //       name: "Avg.Speed"
  //     },
  //     {
  //       uid: "distance",
  //       name: "Distance"
  //     },
  //     {
  //       uid: "location",
  //       name: "Location"
  //     }
  //   ],
  //   activeColumns: ["vehicleName", "from", "to"],
  //   acceptCustomerType: [
  //     CustomerType.SCHOOL,
  //     CustomerType.EMPLOYEETRACKING,
  //     CustomerType.INDIVIDUAL,
  //     CustomerType.COLLEGE,
  //     CustomerType.SME
  //   ]
  // },
  //   ]
  // }
  // new work end
];
